import React, { useState, useEffect } from 'react';
import { Loading } from 'carbon-components-react';
import styled from 'styled-components';

// Components
import { Container, ContentContainer } from '../../components/Wrapper/Wrapper';
import GlobalRegistriesContent from './GlobalRegistriesContent';
import TileHeader from '../../components/TileHeader/TileHeader';
import NewGlobalRegistryModal from './NewGlobalRegistryModal';
import DeleteGlobalRegistryModal from './DeleteGlobalRegistryModal';
// api
import { getAllGlobalRegistries } from '../../api/global-registries';

const GlobalRegistries = ({
}) => {
	// loading is for initial component preloading
	const [loading, setLoading] = useState(true);

  const [globalRegistriesList, setGlobalRegistriesList] = useState(null);
  const [openNewGlobalRegistryModal, setOpenNewGlobalRegistryModal] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [deleteItem, setDeleteItem] = useState(null);
  const [openGlobalRegistryModal, setOpenGlobalRegistryModal] = useState(false);
  const [detailModalMode, setDetailModalMode] = useState("create");
  const [globalRegistry, setGlobalRegistry] = useState(null);

  const refreshGlobalRegistriesList = async () => {
    
    setLoading(true);
    let data = await getAllGlobalRegistries();
    setGlobalRegistriesList(data); 
    if(data){
      setLoading(false);
    }
  }
  const showDeleteConfirm = (itemId) => {
    setOpenDeleteModal(true);
    setDeleteItem(itemId);
  };

  const closeModal = () => {
    setOpenGlobalRegistryModal(false);
    setGlobalRegistry(null);
  };
  
  const addNewGlobalRegistry = () => {
    openGlobalRegistryModal(true);
  };

  useEffect(async () => {
    refreshGlobalRegistriesList();
  }, []);

  return (
    <Container>
      <ContentContainer>
        <TileHeader 
            title="Global Registries"
            subtitle="A list of all global registries."
            size="lg"
        />

        
				{
					loading ? 
					<Loading

          /> 
					:
					<></>
				}
				

        <GlobalRegistriesContent
          globalRegistriesList={globalRegistriesList} 
          setOpenNewGlobalRegistryModal={setOpenNewGlobalRegistryModal}
          onDeleteClicked={showDeleteConfirm}
          setOpenNewGlobalRegistryModal={setOpenGlobalRegistryModal}
          setDetailModalMode={setDetailModalMode}
          setGlobalRegistry={setGlobalRegistry}
          setMode={setDetailModalMode}
          />

        <NewGlobalRegistryModal
          open={openGlobalRegistryModal}
          globalRegistryData={globalRegistry}
          refreshList={refreshGlobalRegistriesList}
          onClose={closeModal}
          mode={detailModalMode}
        />
        <DeleteGlobalRegistryModal
          open={openDeleteModal}
          refreshList={refreshGlobalRegistriesList}
          onClose={() => setOpenDeleteModal(false)}
          globalRegistryList={globalRegistriesList}
          deleteItem={deleteItem}
        />
        
      </ContentContainer>
    </Container>
  );
};

export default GlobalRegistries;